/**
 * Navigation principale sidebar.
 *
 * 8 sections fixes (cf. plan v3 Sprint 2). Les sections marquees `enabled: false`
 * ne sont pas encore implementees — la Sidebar les affiche tout de meme avec
 * un visuel "à venir" (variant `placeholder`) pour donner la photographie
 * complete du produit. Les routes correspondantes pointent toutes sur
 * `<ComingSoonPage>` jusqu'a ce que leur sprint dedie les active.
 */
import {
  BarChart3,
  BookOpen,
  Briefcase,
  Clock,
  FileText,
  Frame,
  Home,
  Image as ImageIcon,
  Send,
  Settings,
  type LucideIcon,
} from 'lucide-react'

export interface NavSection {
  id: string
  label: string
  icon: LucideIcon
  path: string
  /** True quand le sprint correspondant a livre la route. */
  enabled: boolean
  /** Sprint qui activera l'entree (info indicative pour le placeholder). */
  enableIn?: string
}

export const NAV_ITEMS: NavSection[] = [
  // S6 PR5 — Tableau de bord activé : Masthead + KPI + AlertBar +
  // ActivityFeed + SignalsPanel. 4 useQuery indépendants (isolation
  // des pannes côté FE).
  {
    id: 'dashboard',
    label: 'Tableau de bord',
    icon: Home,
    path: '/dashboard',
    enabled: true,
  },
  {
    id: 'works',
    label: 'Œuvres',
    icon: ImageIcon,
    path: '/works',
    enabled: true,
  },
  {
    id: 'mockups',
    label: 'Mockups',
    icon: Frame,
    path: '/mockups',
    enabled: true,
  },
  {
    id: 'drafts',
    label: 'Contenus',
    icon: FileText,
    path: '/drafts',
    enabled: true,
  },
  {
    id: 'queue',
    label: 'File de publication',
    icon: Send,
    path: '/queue',
    enabled: true,
  },
  {
    id: 'photobook',
    label: 'Livre photo',
    icon: BookOpen,
    path: '/photobook',
    enabled: true,
  },
  {
    id: 'history',
    label: 'Historique',
    icon: Clock,
    path: '/history',
    enabled: false,
    enableIn: 'S10',
  },
  {
    id: 'stats',
    label: 'Statistiques',
    icon: BarChart3,
    path: '/stats',
    enabled: false,
    enableIn: 'S10',
  },
  {
    id: 'orders',
    label: 'Commandes',
    icon: Briefcase,
    path: '/custom-orders',
    enabled: false,
    enableIn: 'S10',
  },
  {
    id: 'settings',
    label: 'Paramètres',
    icon: Settings,
    path: '/settings',
    enabled: true,
  },
]
